import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const tabClass = ({ isActive }) =>
  [
    "px-3 py-2.5 text-sm font-semibold rounded-t-lg border-b-2 -mb-px transition-colors",
    isActive
      ? "border-blue-700 text-blue-900 bg-blue-50/80"
      : "border-transparent text-slate-600 hover:text-blue-800 hover:bg-blue-50/40",
  ].join(" ");

const MedmateAdminLayout = () => (
  <div className="w-full max-w-7xl mx-auto h-full min-h-0 flex flex-col">
    <nav
      className="flex-shrink-0 flex flex-wrap gap-1 border-b border-slate-200 mb-1"
      aria-label="Medmate admin sections"
    >
      <NavLink to="/medmate-admin/overview" className={tabClass}>
        Overview
      </NavLink>
      <NavLink to="/medmate-admin/medmate-linking" className={tabClass}>
        Medmate Linking
      </NavLink>
      <NavLink to="/medmate-admin/reports" className={tabClass}>
        Reports
      </NavLink>
    </nav>
    <div className="flex-1 min-h-0 min-w-0 flex flex-col">
      <Outlet />
    </div>
  </div>
);

export default MedmateAdminLayout;
